import { Component } from '@angular/core';

@Component({
    selector: 'aa-header-logo',
    templateUrl: './header-logo.component.html',
    styleUrls: [
        './header-logo.component.scss'
    ],
    standalone: false
})
export class HeaderLogoComponent
{
    constructor() { }
}
